import script from "./PracticeRoomsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PracticeRoomsSection.vue?vue&type=script&setup=true&lang=js"

import "./PracticeRoomsSection.vue?vue&type=style&index=0&id=bafa1f9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bafa1f9c"]])

export default __exports__